import { format, parseISO } from 'date-fns';
import React from 'react';
import { type TAPlan } from '../../TAPlan/TAPlan.types';
import { getTAPlanIcon } from '../../TAPlan/TAPlanUtils';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util';
import sv from '../../Util/customDateFnsSwedish';
import formatCloseRelative from '../../Util/formatCloseRelative';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function TAPlanTemplate({
    statusText,
    typeOfWork,
    locationDescription,
    trafficConsequence,
    affectedTrafficTypesDisplay,
    validFrom,
    validTo,
    detailsPath,
    importedTime,
    status,
}: TAPlan): React.ReactElement {
    const validFromISO = parseISO(validFrom);
    const validToISO = validTo ? parseISO(validTo) : null;
    const importedTimeISO = parseISO(importedTime);

    return (
        <PopupTemplateWrapper
            iconId={getTAPlanIcon(status)}
            title={`${statusText}${!typeOfWork || typeOfWork.toLowerCase() == 'ej valt' ? '' : ', ' + typeOfWork.toLowerCase()}`}
        >
            <div className="taplan-popup">
                <h3>{locationDescription}</h3>
                <p>{trafficConsequence}</p>
                <p>
                    <b>Trafikslag som påverkas: </b>
                    {`${capitalizeFirstLetter(affectedTrafficTypesDisplay)}`}
                </p>
                <table className="mt-2">
                    <tbody>
                        <tr>
                            <td>Gäller från:</td>
                            <td>
                                <TimeElement date={validFromISO}>{format(validFromISO, 'P', { locale: sv })}</TimeElement>
                            </td>
                        </tr>
                        <tr>
                            <td>Gäller till:</td>
                            <td>
                                {validTo ? (
                                    <TimeElement date={validToISO}>{format(validToISO, 'P', { locale: sv })}</TimeElement>
                                ) : (
                                    'Gäller tills vidare'
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    <a href={detailsPath}>Se mer information och kartskiss med avstängningar.</a>
                </p>
                <dl className="popup-details">
                    <dt>Uppdaterad:</dt>
                    <dd title={format(importedTimeISO, 'Pp')}>
                        <TimeElement date={importedTimeISO}>{capitalizeFirstLetter(formatCloseRelative(importedTimeISO))}</TimeElement>
                    </dd>
                </dl>
            </div>
        </PopupTemplateWrapper>
    );
}
